import reverse from "lodash/reverse";
import sortBy from "lodash/sortBy";
import {HiMenu} from "react-icons/hi";
import {useNavigate} from "react-router";

import {Divider} from "@/components/divider/Divider.tsx";
import {DropdownHeader} from "@/components/dropdown/subComponents/DropdownHeader/DropdownHeader.tsx";
import {DropdownItem} from "@/components/dropdown/subComponents/DropdownItem/DropdownItem.tsx";
import {DropdownButton} from "@/components/dropdownButton/DropdownButton.tsx";
import {IconButton} from "@/components/iconButton/IconButton.tsx";
import {DashboardDefinition} from "@/lib/types/website.ts";
import {MenuItemDelete} from "@/pages/dashboard/display/components/dashboardActionBar/menuItems/MenuItemDelete.tsx";

interface DashboardActionMenuProps {
  dashboardDef: DashboardDefinition;
  dashboardDefs: DashboardDefinition[];
  setShowEditDashboardModal: (show: boolean) => void;
}

export const DashboardActionMenu = ({
  dashboardDef,
  dashboardDefs,
  setShowEditDashboardModal,
}: DashboardActionMenuProps) => {
  const navigate = useNavigate();

  return (
    <DropdownButton data-testid="dashboardMenu" as={IconButton} icon={HiMenu} size={"large"} variant={"secondary"}>
      <DropdownItem data-testid="customizeButton" onClick={() => setShowEditDashboardModal(true)}>
        Customize
      </DropdownItem>
      <Divider />
      <DropdownItem id={"create-new-dashboard"} onClick={() => navigate("/dashboard/new")}>
        Create Dashboard
      </DropdownItem>
      <MenuItemDelete dashboardDef={dashboardDef} />
      <Divider />
      <DropdownHeader>All Dashboards</DropdownHeader>
      {reverse(sortBy(dashboardDefs, (d) => d.ordering)).map((dashboardDefinition: DashboardDefinition) => (
        <DropdownItem
          id={`${dashboardDefinition.id}`}
          key={`${dashboardDefinition.id}`}
          onClick={() => navigate(`/dashboard/${dashboardDefinition.id}`)}
        >
          {dashboardDefinition.name}
        </DropdownItem>
      ))}
    </DropdownButton>
  );
};
